import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Link, Icon } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import { getCampaignUrl } from 'store/campaign/campaignSelectors';
import { useDataLayer } from 'hooks/useDataLayer';

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${themeGet('colors.greys.charcoal')};

  &:hover {
    color: ${themeGet('colors.greys.charcoal')};
  }
`;

const CampaignMessageLink = ({ title, children }) => {
  const cta = useSelector(getCampaignUrl);
  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'Campaign Blue Banner', value: `${title} Selected` });
  }, [emitInteractionEvent, title]);

  if (!cta) return <Fragment>{children}</Fragment>;

  return (
    <StyledLink href={cta} onClick={handleOnClick} target="_blank" rel="noreferrer noopener" aria-label={title} data-testid="link-wrapper">
      {children}
      <Icon name="chevronRight" />
    </StyledLink>
  );
};

CampaignMessageLink.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

CampaignMessageLink.defaultProps = {
  title: undefined,
};

export default CampaignMessageLink;
